module.exports = __webpack_public_path__ + "static/banner-cta-c8f83723ded767e0803f1b08a14f7751.jpg";